export default {
  logoColor: '#FF7300'
};



/** WEBPACK FOOTER **
 ** ./docs/shared/Colors.js
 **/